export type Faq = {
  q: string;
  a: string;
};

export const faqs: Faq[] = [
  {
    q: '西瓜瓜田上的「主角」「小号」信息是怎么整理出来的？',
    a: '我们把公开平台上已经出现的讨论、当事人回应和媒体报道按时间顺序归拢，再标注每条信息的来源与可信度。所有档案只做梳理与提示，不代替任何一方的正式声明。',
  },
  {
    q: '为什么有些瓜的结论写着「暂无法确认」？',
    a: '娱乐事件的很多线索来自截图和匿名爆料，缺少可交叉验证的来源。遇到这种情况，我们会如实标注「暂无法确认」，而不是替大家下结论。',
  },
  {
    q: '如何区分某个账号是不是传说中的小号？',
    a: '单看昵称和头像并不可靠。我们通常从注册时间、发言措辞、活跃时段、关注列表重合度几个维度去看，并给出「可能相关 / 存疑 / 无关」的判定，而不是直接下死结论。',
  },
  {
    q: '网站会发布未经核实的私人信息吗？',
    a: '不会。我们不公开任何非公众人物的个人隐私，包括真实姓名、住址、联系方式等；涉及未成年人或普通素人的内容一律不做展开。',
  },
  {
    q: '内容多久更新一次？',
    a: '热点事件在追踪期内通常每天更新一次进展；已完结的瓜会保留档案并做一次回顾整理。你可以通过页面底部的「吃瓜速递」订阅进展提醒。',
  },
  {
    q: '看到与本站不一样的说法，应该相信谁？',
    a: '建议以当事人或工作室的正式声明为准。吃瓜本质上是一场信息整理，欢迎把可靠来源发给我们，我们会核对后更新档案。',
  },
];